import { render, staticRenderFns } from "./DataTypesList.vue?vue&type=template&id=aa2ee55c&scoped=true"
import script from "./DataTypesList.vue?vue&type=script&lang=js"
export * from "./DataTypesList.vue?vue&type=script&lang=js"
import style0 from "./DataTypesList.vue?vue&type=style&index=0&id=aa2ee55c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aa2ee55c",
  null
  
)

export default component.exports